<template>
  <div>
    <div class="completed-recommendation-section base-type-layout w-100 h-100">
      <!-- CONFETTI -->
      <div class="confetti">
        <img v-lazy="localImg('confetti.svg')" />
      </div>
      <!-- CONFETTI -->

      <!-- MODAL SECTION  -->
      <transition name="fade" mode="out-in">
        <section class="modal-section mx-auto">
          <div class="modal-card position-relative rounded-10">
            <!-- COMPLETED IMAGE -->
            <div class="completed-image">
              <img v-lazy="localImg('CompletedParty.svg')" />
            </div>
            <!-- COMPLETED IMAGE -->

            <!-- CLOSE ICON -->
            <div
              class="close-bar avatar position-absolute color_white_bg pointer"
              @click="$emit('close-triggered')"
            >
              <span class="icon-decline font-18 flex-center"></span>
            </div>
            <!-- CLOSE ICON -->

            <div class="title-text font-weight-bold brand_navy">
              Daily recommendations completed
            </div>

            <!-- RECOMMEND CARD -->
            <div
              class="recommend-card d-flex justify-content-between align-items-center nowrap"
              v-for="(item, index) in recommendations"
              :key="index"
            >
              <div
                class="left d-flex justify-content-start align-items-center nowrap"
              >
                <template v-if="item.type === 'video'">
                  <div class="card-image avatar">
                    <img v-lazy="item.image" class="avatar-img" />
                    <!-- OVERLAY -->
                    <div
                      class="position-absolute w-100 h-100 rgba-black-light"
                    ></div>
                    <!-- PLAY ICON -->
                    <div
                      class="play-icon position-absolute icon-play-bg brand-accent font-17"
                    ></div>
                  </div>
                </template>
                <template v-if="item.type === 'single'">
                  <div class="card-image avatar">
                    <img v-lazy="item.topic.image" class="avatar-img" />
                  </div>
                </template>
                <template v-if="item.type === 'mix'">
                  <div class="card-image avatar">
                    <img v-lazy="item.topic[0].image" class="avatar-img" />
                  </div>
                </template>

                <div class="card-info">
                  <div class="meta-text color_grey_dark font-weight-bold">
                    Practiced
                  </div>

                  <template v-if="item.type === 'video'">
                    <div class="topic-text color_text">
                      {{ item.new_title }}
                    </div>
                  </template>
                  <template v-if="item.type === 'single'">
                    <div class="topic-text color_text">
                      {{ item.topic.topic }}
                    </div>
                  </template>
                  <template v-if="item.type === 'mix'">
                    <div class="topic-text color_text">
                      {{ item.topic[0].topic }}
                    </div>
                  </template>
                </div>
              </div>

              <!-- RIGHT SECTION -->
              <div class="right">
                <div class="completed-mark rounded-circle">
                  <span
                    class="icon-accept font-20 brand_white flex-center"
                  ></span>
                </div>
              </div>
              <!-- RIGHT SECTION -->
            </div>
            <!-- RECOMMEND CARD -->

            <!-- LOAD MORE BUTTON -->
            <div class="load-more-btn">
              <button
                @click="$emit('load-new-recommendation')"
                class="btn btn-accent brand_navy font-weight-bold font-11"
              >
                Load another set of recommendation
              </button>
            </div>
            <!-- LOAD MORE BUTTON -->

            <!-- DONE BUTTON -->
            <div class="done-btn">
              <button
                @click="$emit('close-triggered')"
                class="btn transparent_bg z-depth-0 brand_navy font-weight-bold font-11"
              >
                I’m done for today
              </button>
            </div>
            <!-- DONE BUTTON -->
          </div>
        </section>
      </transition>
      <!-- MODAL SECTION  -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CompletedRecommendation",

  props: {
    recommendations: Array,
  },

  computed: {},
};
</script>

<style lang="scss">
.completed-recommendation-section {
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto !important;
  z-index: 2000;
  background-color: #0f0f0f;
  transition: all 0.5s ease-in-out;
  animation: panel-slide-down 0.6s ease-in-out forwards;

  .confetti {
    position: absolute;
    width: 100%;
    height: auto;
    @include flex_row_center_nowrap;
    align-items: flex-start;
    img {
      position: relative;
      width: auto;
      height: auto;
    }
  }

  .modal-section {
    height: 100vh;

    .modal-card {
      @include transform_center;
      width: 700px;
      height: auto;
      padding: 25px;
      background: #fceacf;

      .completed-image {
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .close-bar {
        top: 20px;
        right: 20px;
      }

      .title-text {
        font-size: 18px;
        line-height: 25px;
        margin-bottom: 15px;
      }

      .recommend-card {
        width: 65%;
        padding: 15px 2px;
        border-bottom: 1px solid #e5e5e5;

        .left {
          .card-image {
            @include equal_min_edge(48);
            border-radius: 5px;
            margin-right: 12px;

            img {
              @include img_cover;
            }

            .play-icon {
              @include transform_center;
              z-index: 9;
              color: $brand_accent !important;
            }
          }
          .meta-text {
            font-size: 11px;
            line-height: 14px;
            margin-bottom: 3px;
          }
          .topic-text {
            font-size: 14.5px;
            line-height: 19px;
          }
        }
        .right {
          .completed-mark {
            background: #24ae5f;
            @include equal_min_edge(24);
          }
        }
      }

      .load-more-btn {
        margin-top: 30px;
        margin-bottom: 20px;
      }

      .done-btn {
        margin-bottom: 70px;
        transition: all 0.6s ease-in-out;
        &:hover {
          .btn {
            color: $brand_accent !important;
          }
        }
      }

      @include breakpoint_max(md) {
        width: 580px;
      }

      @include breakpoint_max(sm) {
        width: 97%;
      }
    }
  }
}
</style>
